import { render, staticRenderFns } from "./calcstatistics.vue?vue&type=template&id=6f47357b&scoped=true"
import script from "./calcstatistics.vue?vue&type=script&lang=js"
export * from "./calcstatistics.vue?vue&type=script&lang=js"
import style0 from "./calcstatistics.vue?vue&type=style&index=0&id=6f47357b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f47357b",
  null
  
)

export default component.exports